import React from 'react';
import clsx from 'clsx';
import Image from 'components/commercetools-ui/atoms/image';
import Link from 'components/commercetools-ui/atoms/link';
import Breadcrumb from 'components/commercetools-ui/molecules/breadcrumb';
import { NavLeftIcon } from 'components/icons';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';
import { Category as CategoryFromEntity } from 'types/entity/category';
import { NotFoundProps } from './types';
import { fontWeightMap } from '../product-category-slider/config';

const NotFound = (data: NotFoundProps) => {
  const { link } = data;
  const [isDesktopSize] = useMediaQuery(desktop);
  const homeBreadCrumb = {
    name: data?.breadCrumbsHome ?? 'Home',
    categoryId: '_home',
    _url: '/',
  } as CategoryFromEntity;

  return (
    <div className="flex min-h-screen flex-col justify-between bg-white">
      <div className="flex flex-1 flex-col justify-between">
        <div
          className="mx-20 sm:mx-24 md:mx-75 lg:mx-76 xl:mx-0"
          data-ffid="ctr-notfound"
          data-testid="notfound-container"
        >
          <div className="mx-auto max-w-screen-xl transition-all duration-300">
            <div className="md:px-24 lg:px-16">
              <Breadcrumb backCategory={homeBreadCrumb} className="col-span-12 my-24 w-fit lg:block">
                <li data-ffid="li-back-home">
                  <Link link={'/'} data-ffid="lnk-back-home" className="mr-6 block lg:mr-10">
                    <NavLeftIcon data-ffid="" className="size-20 lg:size-24" />
                  </Link>
                </li>

                <Link link="" data-ffid="lnk-notfound" className="text-14 text-primary dark:text-white">
                  {data?.breadCrumbsHome}
                </Link>

                <Link link="" data-ffid="lnk-404-notfound" className="text-14 font-bold text-primary dark:text-white">
                  {isDesktopSize && data?.breadCrumbsNotFoundText}
                </Link>
              </Breadcrumb>
            </div>
          </div>
        </div>
        <div className="md:mt-0 lg:mt-40">
          <h2
            data-ffid="lbl-notfound-heading"
            data-testid="notfound-heading"
            className={clsx(fontWeightMap[data?.headingText ? data?.headingText?.[0]?.textStyle : ''], 'text-center')}
            style={{
              color: data?.headingText?.[0]?.fontColor,
              fontSize: isDesktopSize
                ? data?.headingText?.[0]?.fontSizeDesktop
                : data?.headingText?.[0]?.fontSizeMobile,
            }}
          >
            {data?.headingText?.[0]?.headingLabel}
          </h2>
          <p
            className="text-center"
            data-ffid="lbl-notfound-description-label"
            style={{
              fontSize: isDesktopSize
                ? data?.headingText?.[0]?.fontSizeDescriptionDesktop
                : data?.headingText?.[0]?.fontSizeDescriptionMobile,
            }}
          >
            {data?.headingText?.[0]?.descriptionLabel}
            <Link className="text-blue-200 underline" data-ffid="lnk-notfound-link-text" link={link}>
              {` ${data?.linkText}`}
            </Link>
          </p>
        </div>

        <div data-testid="notfound-images">
          <section className="relative w-full overflow-hidden">
            <div className="aspect-[4/4] sm:aspect-[4/3] md:aspect-[4/3] lg:aspect-[21/9]">
              <Image
                data-ffid={`img-notfound-1`}
                media={data?.backgroundImage?.media}
                alt={'Background image'}
                className="absolute inset-0 size-full object-cover object-[60%] pt-30 md:object-cover md:pt-0 lg:object-contain lg:object-[50%]"
                data-testid={`notfound-image-1`}
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
